import { ScheduledAdminError } from '@/views/community/channel/scheduled/admin/scheduled-admin.error';

export default ScheduledAdminError;
